import { apiClient } from "@/services/api-client";
import { mapGetters } from "vuex";

export const logPageMixin = {
  computed: {
    ...mapGetters(["getUsername"])
  },
  methods: {
    call() {
      apiClient
        .logPagina({ gebruiker: this.getUsername, pagina: this.$route.path })
        .then()
        .catch();
    }
  },
  created() {
    this.call();
  },
  beforeRouteUpdate(to, from, next) {
    this.call();
    next();
  }
};
